<template>
    <div v-if="data" class="card">
      <div class="text-lg">
        <span class="font-medium">{{ data.title[lang] }}</span>
        <img class="absolute right-8 w-5 h-5 cursor-pointer"
          v-tooltip="data.tooltip[lang]" src="@/assets/iconfinder.svg" alt="icon finder" />
        <span v-if="data.value">: {{ data.value }}</span>
      </div>
      <div class="mx-5">
        <ol v-if="data.list?.length > 0">
          <li v-for="v in data.list" :key="v">{{ v }}</li>
        </ol>
        <span v-if="data.text[lang]" v-html="data.text[lang]"></span>
      </div>
    </div>
  </template>

<script>
export default {
  name: 'OMindsetDevelopmentTipComponent',
  props: {
    data: Object,
  },
  data() {
    return {};
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
  },
};
</script>
  <style scoped>
  .card {
    position: relative;
    margin: 5px;
    border-color: rgb(244, 151, 24);
  }
  </style>
